import Sidebar from "./Sidebar";
// import Header from "./header";
// import Footer from "./footer";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  requestDashboard
} from "../Redux/actions";
import image from "../images/extraLogo.png";
import image1 from "../images/extraLogo.png";
import CanvasJSReact from "./canvasjs.react";
// import firebase from "firebase";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

function Home(props) {

  const [lastSixJobData, setlastSixJobData] = useState([]);
  const [lastSixEmpData, setlastSixEmpData] = useState([]);
  const [monthjob, setmonthjob] = useState({});
  const [monthjobdata, setmonthjobdata] = useState([]);
  const [monthWiseAppliedjobData, setmonthWiseAppliedjobData] = useState({});
  const [monthWiseAppliedjobDatadata, setmonthWiseAppliedjobDatadata] = useState([]);
  const [categoryJobData, setcategoryJobData] = useState([]);
  const [categoryJobDatadata, setcategoryJobDatadata] = useState([]);
  const [companyJobData, setcompanyJobData] = useState([]);
  const [companyJobDatadata, setcompanyJobDatadata] = useState([]);
  const [functionalCanditateData, setfunctionalCanditateData] = useState([]);
  const [functionalCanditateDatadata, setfunctionalCanditateDatadata] = useState([]);
  const [uid, setUID] = useState('0');
  const [logindetails, setLoginDetails] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [companies, setCompanies] = useState([]);
  const [user, setUser] = useState(null);
  const [dashboarddata, setDashboardData] = useState({
    SaleOrderCount: 0, SaleOrderAmount: 0, SaleCount: 0, SaleAmount: 0, PurchaseCount: 0, PurchaseAmount: 0, Expenses: 0, Cash: 0, CC: 0, UPI: 0, ClientBalance: 0, VendorBalance: 0, CutOff: 0,
    LogSaleDelete: 0, LogSaleEdit: 0, LogPurchaseDelete: 0, LogPurchaseEdit: 0, LogSaleOrderDelete: 0, LogSaleOrderEdit: 0, LoCartDelete: 0, LogCartEdit: 0,
    LogExpenseDelete: 0, LogExpenseEdit: 0
  });

  useEffect(() => {
    let data1 = JSON.parse(localStorage.getItem("user"));
    console.log(data1.data.userToken);
    setUser(data1.data);
    props.requestDashboard(
      {
        data: {
          param1: data1.data.userToken,
          token: "",
        },
      }
    );
  }, []);

  useEffect(() => {
    let dashboardData = props.data.dashboardData;
    console.log(dashboardData);
    if (dashboardData !== undefined) {
      if (dashboardData?.data?.status === 1) {
        let companiesJSON = JSON.parse(dashboardData.data.data.companies);
        if (companiesJSON && companiesJSON.length > 0) {
          setCompanyId(companiesJSON[0].token);
          localStorage.setItem("companyToken", companiesJSON[0].Token);
          // localStorage.setItem("companyToken", '611337539322');
          localStorage.setItem("products", dashboardData.data.data.products);
          localStorage.setItem("contacts", dashboardData.data.data.contacts);
          localStorage.setItem("store", dashboardData.data.data.store);

          let count = dashboardData.data.data;
          console.log(count);
          setDashboardData(adddata => ({
            ...adddata,
            SaleOrderCount: count.saleOrderCount, SaleOrderAmount: count.saleOrderAmount, SaleCount: 0, SaleAmount: 0, PurchaseCount: 0, PurchaseAmount: 0, Expenses: 0, Cash: 0, CC: 0, UPI: 0, ClientBalance: 0, VendorBalance: 0, CutOff: 0
          }));
        let companyJobDatadata = [];
        let sbd = JSON.parse(dashboardData.data.data.salesByDate);
        sbd.map((i, index) => {
          companyJobDatadata.push({
            label: i.date,
            y: i.totalGrand,
          });
        });
        setcompanyJobDatadata(companyJobDatadata)

          if (user != undefined) {
            props.requestDashboard(
              {
                data: {
                  param1: user.userToken,
                  token: companiesJSON[0].Token,
                },
              })
          }
          props.data.dashboardData = undefined;
        }
        setCompanies(companiesJSON);
      }
    }
  }, [props.data.dashboardData]);

  function onChangeCompany(e) {
    console.log("onChangeCompany", e.target.value);
    setCompanyId(e.target.value);
  }

  // useEffect(() => {
  //   let formfieldData = props.data.loginData.data.data;
  //   setLoginDetails(formfieldData.admin_detail);
  //   setUID(formfieldData.id);
  //   console.log(localStorage.getItem("user"));
  // }, [props.data.loginData.data.data]);

  //   function componentDidMount(){
  //   const messaging = firebase.messaging()
  //   messaging.requestPermission().then(() => {
  //     return messaging.getToken()
  //   }).then(token => {
  //     console.log('Token :', token)
  //   }).catch(() =>{
  //     console.log('error :');
  //   });
  // }

  useEffect(() => {
    // props.requestAdminCategoryJob();
    // props.requestAdminAllCount();
    // props.requestAdminMonthAppliedJob();
    // props.requestAdminMonthJob();
    // props.requestAdminCompanyJob();
    // props.requestAdminSixCompanies();
    // props.requestAdminSixJobs();
    // props.requestAdminFunctionalCandidate();
  }, [uid]);

  const [allCountData, setallCountData] = useState({})
  const [allCountryData, setallCountryData] = useState({})
  const [allStateData, setallStateData] = useState({})
  const [allCityData, setallCityData] = useState({})

  // useEffect(() => {
  //   console.log("count data from home");
  //   console.log(props.data.allCountData);

  //   let counts = props.data.allCountData
  //   console.log(counts);
  //   if (counts !== undefined) {
  //     if (counts.data) {
  //       setallCountData(counts.data.data)
  //     }
  //   }
  // }, [props.data.allCountData])

  // useEffect(() => {
  //   let lastSixJobData = props.data.lastSixJobData;
  //   if (lastSixJobData !== undefined) {
  //     if (lastSixJobData?.data?.status == "sucess") {
  //       setlastSixJobData(lastSixJobData.data.data);
  //     }
  //   }
  // }, [props.data.lastSixJobData]);

  // useEffect(() => {
  //   let lastSixEmpData = props.data.lastSixEmpData;
  //   if (lastSixEmpData !== undefined) {
  //     if (lastSixEmpData?.data?.status == "sucess") {
  //       setlastSixEmpData(lastSixEmpData.data.data);
  //     }
  //   }
  // }, [props.data.lastSixEmpData]);

  // useEffect(() => {
  //   let monthjob = props.data.monthjob;
  //   if (monthjob !== undefined) {
  //     if (monthjob?.data?.status == "sucess") {
  //       setmonthjob(monthjob.data.data);
  //       monthJobfun();
  //     }
  //   }
  // }, [props.data.monthjob]);

  // useEffect(() => {
  //   let monthWiseAppliedjobData = props.data.monthWiseAppliedjobData;
  //   if (monthWiseAppliedjobData !== undefined) {
  //     if (monthWiseAppliedjobData?.data?.status == "sucess") {
  //       setmonthWiseAppliedjobData(monthWiseAppliedjobData.data.data);
  //       monthAppliedJobfun();
  //     }
  //   }
  // }, [props.data.monthWiseAppliedjobData]);

  function monthJobfun() {
    Object.keys(monthjob).map((key) => {
      monthjobdata.push({
        y: monthjob[key][0],
        label: key,
      });
    });
  }

  function monthAppliedJobfun() {
    Object.keys(monthWiseAppliedjobData).map((key) => {
      monthWiseAppliedjobDatadata.push({
        y: monthWiseAppliedjobData[key][0],
        label: key,
      });
    });
  }

  const options = {
    exportEnabled: true,
    zoomEnabled: true,
    animationEnabled: true,
    axisY: {
      title: "Number of Jobs",
    },
    toolTip: {
      shared: true,
    },
    data: [
      {
        type: "spline",
        name: "Posted Job",
        showInLegend: true,
        dataPoints: monthjobdata,
      },
      {
        type: "spline",
        name: "Applied Job",
        showInLegend: true,
        dataPoints: monthWiseAppliedjobDatadata,
      },
    ],
  };

  // useEffect(() => {
  //   let categoryJobData = props.data.categoryJobData;
  //   if (categoryJobData !== undefined) {
  //     if (categoryJobData?.data?.status == "sucess") {
  //       setcategoryJobData(categoryJobData.data.data);
  //       categoryJobfun();
  //     }
  //   }
  // }, [props.data.categoryJobData]);

  function categoryJobfun() {
    categoryJobData.map((i, index) => {
      categoryJobDatadata.push({
        name: i.name,
        y: i.total_jobsCategorywise,
      });
    });
  }

  // useEffect(() => {
  //   let companyJobData = props.data.companyJobData;
  //   if (companyJobData !== undefined) {
  //     if (companyJobData?.data?.status == "sucess") {
  //       setcompanyJobData(companyJobData.data.data);
  //       companyJobData = companyJobData.data.data
  //       let companyJobDatadata = [];
  //       companyJobData.map((i, index) => {
  //         companyJobDatadata.push({
  //           label: i.name,
  //           y: i.total_companywisejob,
  //         });
  //       });
  //       setcompanyJobDatadata(companyJobDatadata)
  //     }
  //   }
  // }, [props.data.companyJobData]);

  // useEffect(() => {
  //   let functionalCanditateData = props.data.functionalCanditateData;
  //   console.log("functionalCanditateData", functionalCanditateData);
  //   if (functionalCanditateData !== undefined) {
  //     if (functionalCanditateData?.data?.status == "sucess") {
  //       setfunctionalCanditateData(functionalCanditateData.data.data);
  //       functionalCanditateData = functionalCanditateData.data.data
  //       let functionalCanditateDatadata = [];
  //       functionalCanditateData.map((i, index) => {
  //         functionalCanditateDatadata.push({
  //           name: i.name,
  //           y: i.total_companywisejob,
  //         });
  //       });
  //       setfunctionalCanditateDatadata(functionalCanditateDatadata)
  //     }
  //   }
  // }, [props.data.functionalCanditateData]);

  // useEffect(() => {
  //   console.log(functionalCanditateDatadata)
  // }, [functionalCanditateDatadata])

  function todayCount(count) {
    return (count ?
      (<p class="text-success d-flex">
        <i class="mdi mdi-menu-up"></i>
        <span>{count}</span>
      </p>) :
      (<p style={{ visibility: 'hidden' }}>0</p>)
    )
  }
  const options1 = {
    exportEnabled: true,
    zoomEnabled: true,
    animationEnabled: true,
    subtitles: [
      {
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],
    data: [
      {
        type: "doughnut",
        showInLegend: true,
        indexLabel: "{name}: {y}",
        yValueFormatString: "#,###",
        dataPoints: categoryJobDatadata,
      },
    ],
  };
  const functionalCanditateDataoptions = {
    exportEnabled: true,
    responsive: true,
    zoomEnabled: true,
    animationEnabled: true,
    subtitles: [
      {
        verticalAlign: "center",
        fontSize: 24,
        dockInsidePlotArea: true,
      },
    ],
    data: [
      {
        type: "doughnut",
        showInLegend: true,
        indexLabel: "{name}: {y}",
        yValueFormatString: "#,###",
        dataPoints: functionalCanditateDatadata,
      },
    ],
  };
  const companyJobDataoptions = {
    data: [
      {
        type: "column",
        dataPoints: companyJobDatadata,
      }
    ]
  }
  return (
    <>
      <div class="container-scroller">
        {/* <Header name="Home" /> */}
        <div class="container-fluid page-body-wrapper">
          <Sidebar name="Home" />

          <div class="main-panel">
            <div class="content-wrapper">
              <select
                class="select form-control"
                value={companyId}
                name="country"
                id="country"
                onChange={onChangeCompany}
              >
                {companies.map((item) => (
                  <option value={item.token}>{item.Name}</option>
                ))}
              </select>
              <div class="row">
                <div class="col-sm-12">
                  <div class="home-tab">
                    <div class="tab-content tab-content-basic">
                      <div
                        class="tab-pane fade show active"
                        id="overview"
                        role="tabpanel"
                        aria-labelledby="overview"
                      >
                        <div class="row" style={{ marginTop: "-20px" }}>
                          <div className="container-fluid">
                            <div className="row">
                              {[
                                {
                                  title: "Sales",
                                  values: [
                                    { icon: "fa-indian-rupee-sign", value: dashboarddata.Cash || 0 },
                                    { icon: "fa-credit-card", value: dashboarddata.CC || 0 },
                                    { icon: "fa-qrcode", value: dashboarddata.UPI || 0 },
                                  ],
                                },
                                {
                                  title: "Sale Orders",
                                  values: [
                                    { icon: "fa-layer-group", value: dashboarddata.SaleOrderCount || 0 },
                                    { icon: "fa-indian-rupee-sign", value: dashboarddata.SaleOrderAmount || 0 },
                                  ],
                                },
                                {
                                  title: "Purchase",
                                  values: [
                                    { icon: "fa-layer-group", value: dashboarddata.PurchaseCount || 0 },
                                    { icon: "fa-indian-rupee-sign", value: dashboarddata.PurchaseAmount || 0 },
                                  ],
                                },
                                {
                                  title: "Expenses",
                                  values: [
                                    { icon: "fa-indian-rupee-sign", value: dashboarddata.Expenses || 0 },
                                  ],
                                },
                                {
                                  title: "Logs",
                                  values: [
                                    { icon: "fa-cart", value: dashboarddata.Expenses || 0 },
                                  ],
                                },
                              ].map((card, index) => (
                                <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3" key={index}>
                                  <div className="card text-white bg-info h-100 shadow-sm">
                                    <div className="card-body">
                                      <p className="card-title fw-bold">{card.title}</p>
                                      {card.values.map((item, i) => (
                                        <h6 className="rate-percentage" key={i}>
                                          {item.icon && <i className={`fa ${item.icon} me-2`}></i>}
                                          {item.value}
                                        </h6>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-8 d-flex flex-column">
                            <div class="row flex-grow">
                              <div class="col-12 col-lg-4 col-lg-12 grid-margin stretch-card">
                                <div class="card card-rounded">
                                  <div class="card-body">
                                    <div class="d-sm-flex justify-content-between align-items-start">
                                      <div>
                                        <h4 class="card-title card-title-dash">
                                          Reminders
                                        </h4>
                                      </div>
                                    </div>
                                    <div class="table-responsive  mt-1">
                                      <table class="table select-table">
                                        <thead>
                                          <tr>
                                            <th>Date</th>
                                            <th>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {lastSixJobData.map((item, index) => {
                                            const img = item.employee_logo
                                              ? process.env.REACT_APP_API_HOST +
                                              item.employee_logo
                                              : image;
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <div class="d-flex ">
                                                    <a
                                                      href={`/admin/viewCompany/${item.company_id}`}
                                                    >
                                                      {" "}
                                                      <img src={img} alt="" />
                                                    </a>
                                                    <div>
                                                      <a
                                                        href={`/admin/viewCompany/${item.company_id}`}
                                                      >
                                                        {" "}
                                                        <h6>
                                                          {item.company_name}
                                                        </h6>
                                                      </a>
                                                      <p>
                                                        <i class="fa fa-map-marker"></i>{" "}
                                                        {item.city_name},{" "}
                                                        {item.state_name},{" "}
                                                        {item.country_name}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <a
                                                    href={`/admin/viewJob/${item.id}`}
                                                  >
                                                    {" "}
                                                    <h6>{item.title}</h6>
                                                    <p>
                                                      Category: {item.jobs_name}
                                                    </p>
                                                    <p>
                                                      Function Area:{" "}
                                                      {
                                                        item.functional_area_name
                                                      }
                                                    </p>
                                                  </a>
                                                </td>
                                                <td>
                                                  <h6>
                                                    {item.currency_name}{" "}
                                                    {item.salary_from}-
                                                    {item.salary_to}
                                                  </h6>
                                                  <p>
                                                    {item.experience > 0
                                                      ? item.experience +
                                                      "year experienced"
                                                      : "Fresher"}
                                                  </p>
                                                </td>
                                                <td>
                                                  <a
                                                    href={`/admin/viewJob/${item.id}`}
                                                  >
                                                    <button
                                                      class="badge badge-opacity-primary"
                                                      style={{ border: "0px" }}
                                                    >
                                                      <i class="fa fa-eye"></i>
                                                    </button>
                                                  </a>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 d-flex flex-column">
                            <div class="row flex-grow">
                              <div class="col-12 grid-margin stretch-card">
                                <div class="card card-rounded">
                                  <div class="card-body">
                                    <div class="row">
                                      <h6>Logs</h6>
                                      <a className='badge' style={{ height: "30px", alignItems: "center", display: "flex", flexDirection: "row", border: "0px", color: "black", backgroundColor: "#9FE2BF" }}>
                                        Sale 
                                        {/* <i className="fa fa-trash"></i> {dashboarddata.LogSaleDelete} <i className="fa fa-edit"></i>{dashboarddata.LogSaleEdit} */}
                                      </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", display: "flex", flexDirection: "row", border: "0px", color: "white", backgroundColor: "#78281F" }}>
                                        Purchase 
                                        {/* <i className="fa fa-trash"></i> {dashboarddata.LogPurchaseDelete} <i className="fa fa-edit"></i>{dashboarddata.LogPurchaseEdit} */}
                                      </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#4A235A" }}>  Sale Order </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#B00020" }}>  Expenses </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#1B4F72" }}>  </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#154360" }}>  </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#186A3B" }}>  </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#7E5109" }}>  </a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#6E2C00" }}></a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#424949" }}></a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "white", backgroundColor: "#17202A" }}></a>
                                      <a class='badge' style={{ height: "30px", textAlign: "center", justifyContent: "center", display: "flex", flexDirection: "column", border: "0px", color: "black", backgroundColor: "#FFDE03" }}></a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg-8 d-flex flex-column">
                            <div class="row flex-grow">
                              <div class="col-12 col-lg-4 col-lg-12 grid-margin stretch-card">
                                <div class="card card-rounded">
                                  <div
                                    class="card-body"
                                    style={{ padding: "30px" }}
                                  >
                                    <div class="d-sm-flex justify-content-between align-items-start">
                                      <div>
                                        <h4 class="card-title card-title-dash">
                                          {/* Company Wise Jobs */}
                                        </h4>
                                      </div>
                                    </div>
                                    <div
                                      class="chartContainer"
                                      style={{
                                        position: "relative",
                                      }}
                                    >
                                      <br />
                                      <CanvasJSChart options={companyJobDataoptions} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 d-flex flex-column">
                            <div class="row flex-grow">
                              <div class="col-12 grid-margin stretch-card">
                                <div class="card card-rounded">
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-lg-12">
                                        <div class="d-flex justify-content-between align-items-center mb-3">
                                          <h4 class="card-title card-title-dash">
                                            {/* Functional Area Wise Candidates */}
                                          </h4>
                                        </div>
                                        <CanvasJSChart options={functionalCanditateDataoptions} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-8 d-flex flex-column">
                            <div class="row flex-grow">
                              <div class="col-12 col-lg-4 col-lg-12 grid-margin stretch-card">
                                <div class="card card-rounded">
                                  <div class="card-body">
                                    <div class="d-sm-flex justify-content-between align-items-start">
                                      <div>
                                        <h4 class="card-title card-title-dash">
                                          Logs
                                        </h4>
                                      </div>
                                    </div>
                                    <div
                                      class="table-responsive  mt-1"
                                      id="printme"
                                    >
                                      <table class="table select-table">
                                        <thead>
                                          <tr>
                                            <th>Date</th>
                                            <th>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {lastSixEmpData.map((item, index) => {
                                            const img = item.logo
                                              ? process.env.REACT_APP_API_HOST +
                                              item.logo
                                              : image1;
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <div class="d-flex ">
                                                    <a
                                                      href={`/admin/viewCompany/${item.id}`}
                                                    >
                                                      {" "}
                                                      <img src={img} alt="" />
                                                    </a>
                                                    <div>
                                                      <a
                                                        href={`/admin/viewCompany/${item.id}`}
                                                      >
                                                        {" "}
                                                        <h6>{item.name}</h6>
                                                      </a>
                                                      <p>
                                                        <i class="fa fa-map-marker"></i>{" "}
                                                        {item.city_name},{" "}
                                                        {item.state_name},{" "}
                                                        {item.country_name}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <h6>
                                                    <a
                                                      href={`mailto:${item.email}`}
                                                    >
                                                      {item.email}
                                                    </a>
                                                  </h6>
                                                  <p>
                                                    <a
                                                      href={`${item.website}`}
                                                      target="_blank"
                                                    >
                                                      {item.website}
                                                    </a>
                                                  </p>
                                                  {item.fax && (
                                                    <p>
                                                      <a
                                                        href={`callto:${item.fax}`}
                                                      >
                                                        {item.fax}
                                                      </a>
                                                    </p>
                                                  )}
                                                </td>
                                                <td>
                                                  <h6>
                                                    {item.ownership_type_name}
                                                  </h6>
                                                  <p>{item.industries_name}</p>
                                                </td>
                                                <td>
                                                  <a
                                                    href={`/admin/viewCompany/${item.id}`}
                                                  >
                                                    <button
                                                      class="badge badge-opacity-primary"
                                                      style={{ border: "0px" }}
                                                    >
                                                      <i class="fa fa-eye"></i>
                                                    </button>
                                                  </a>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4 d-flex flex-column">
                            <div class="row flex-grow">
                              <div class="col-12 col-lg-4 col-lg-12 grid-margin stretch-card">
                                <div class="card card-rounded">
                                  <div
                                    class="card-body"
                                    style={{ padding: "30px" }}
                                  >
                                    <div class="d-sm-flex justify-content-between align-items-start">
                                      <div>
                                        <h4 class="card-title card-title-dash">
                                          Performance Line
                                        </h4>
                                      </div>
                                    </div>
                                    <div
                                      class="chartContainer"
                                      style={{
                                        position: "relative",
                                      }}
                                    >
                                      <br />
                                      <CanvasJSChart options={options} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <Footer /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestDashboard
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
